<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M9.5 4.49758L12 5.53108L14.5 4.49758C16.1049 3.83414 17.8951 3.83414 19.5 4.49758L21.3714 5.27121C21.751 5.42816 22 5.80819 22 6.23079V18.4735C22 19.0443 21.5523 19.507 21 19.507C20.8728 19.507 20.7467 19.4819 20.6286 19.4331L19.5 18.9665C17.8951 18.3031 16.1049 18.3031 14.5 18.9665L12 20L9.5 18.9665C7.89515 18.3031 6.10485 18.3031 4.5 18.9665L3.37139 19.4331C2.85861 19.6451 2.27664 19.3873 2.07152 18.8573C2.02428 18.7352 2 18.605 2 18.4735V6.23079C2 5.80819 2.24895 5.42816 2.62861 5.27121L4.5 4.49758C6.10485 3.83414 7.89515 3.83414 9.5 4.49758ZM5.26408 6.34587L4 6.86844V17.0141C6.02542 16.254 8.25753 16.2887 10.2641 17.1182L11 17.422V7.282L8.73592 6.34587C7.62037 5.88471 6.37963 5.88471 5.26408 6.34587ZM15.2641 6.34587L13 7.281V17.422L13.7359 17.1182C15.7425 16.2887 17.9746 16.254 20 17.0141V6.86844L18.7359 6.34587C17.6204 5.88471 16.3796 5.88471 15.2641 6.34587Z"
    fill="currentColor"
  />
</svg>
